'use client'
import { useParams } from 'react-router-dom';
import { Typography, Box, TextField, Grid } from '@mui/material';
import StandardModal from '@/components/modals/StandardModal';
import { SPACING } from '@/app/constants/layout-constants';
import { useTodayLocationVisit } from '@/hooks/api/useLocationVisits';
import { useUpsertAtmEvents } from '@/hooks/useLocation';
import { useNotification } from '@/contexts/NotificationContext';
import ReportRejectActionButton from '../reject/ReportRejectActionButton';
export interface IAtmValue {
  cassette1Load: number;
  cassette2Load: number;
  cassette3Load: number;
  cassette4Load: number;
  startAmount: number;
  load: number;
  balanceAtDeparture: number;
  locationId: number | undefined;
  assetId: string;
  atmId: number | undefined;
}

interface ILocationVisitAtmFormProps {
  atmValues: IAtmValue[];
  setAtmValues: (value: IAtmValue[]) => void;
  handleDataRefresh: () => void;
  openAtmModal: boolean;
  setOpenAtmModal: (value: boolean) => void;
}

const LocationVisitAtmForm: React.FC<ILocationVisitAtmFormProps> = ({ atmValues, setAtmValues, handleDataRefresh, openAtmModal, setOpenAtmModal }) => {
  const { locationId } = useParams();
  const upsertAtmEventsMutation = useUpsertAtmEvents();
  const { showSuccess, showError } = useNotification();
  const { data: todayVisitData } = useTodayLocationVisit();
  
  const todayVisit = todayVisitData && locationId && Number(todayVisitData.locationId) === Number(locationId) ? todayVisitData : null;

  const handleBlur = (index: number, field: keyof IAtmValue, value: string) => {
    const updatedAtmValues = [...atmValues];
    updatedAtmValues[index] = {
      ...updatedAtmValues[index],
      [field]: Number(value) || 0,
    };
    setAtmValues(updatedAtmValues);
  };

  return (
    <StandardModal
      title="ATM Service Log"
      open={openAtmModal}
      secondaryAction={<ReportRejectActionButton type="atm" locationIdFilter={Number(locationId)} />}
      maxWidth="xl"
      handleClose={() => setOpenAtmModal(false)}
      action={async () => {
        let upsertValues = atmValues.map((atmEvent) => {
          return {
            ...atmEvent,
            locationId: todayVisit?.locationId,
          };
        })
        console.log("atmValues", upsertValues);
        upsertAtmEventsMutation.mutate({ events: upsertValues, locationVisitId: todayVisit?.id }, {
          onSuccess: () => {
            handleDataRefresh();
          },
          onError: (error: any) => {
            showError(error.message || 'Failed to update ATM events');
          },
        });
        setOpenAtmModal(false);
      }}
    >
      <Box style={{ paddingTop: SPACING.md }}>
        <Grid container spacing={2} sx={{ padding: 1, borderBottom: "2px solid #000", fontWeight: "bold", backgroundColor: "#f5f5f5", marginBottom: 1 }}>
          <Grid size={1} sx={{ flexGrow: 1 }}><Typography variant="subtitle1">Asset ID</Typography></Grid>
          <Grid size={1} sx={{flexGrow:1}}><Typography variant="subtitle1">Start Amount</Typography></Grid>
          <Grid size={1} sx={{flexGrow:1}}><Typography variant="subtitle1">Cassette 1 ($20)</Typography></Grid>
          <Grid size={1} sx={{flexGrow:1}}><Typography variant="subtitle1">Cassette 2 ($20)</Typography></Grid>
          <Grid size={1} sx={{flexGrow:1}}><Typography variant="subtitle1">Cassette 3 ($20)</Typography></Grid>
          <Grid size={1} sx={{flexGrow:1}}><Typography variant="subtitle1">Cassette 4 ($20)</Typography></Grid>
          <Grid size={1} sx={{ flexGrow: 1 }}><Typography variant="subtitle1">Balance at Departure</Typography></Grid>
        </Grid>
        {atmValues.map((atm, index) => {
          atm.balanceAtDeparture = atm.startAmount + (atm.cassette1Load * 20) + (atm.cassette2Load * 20) + (atm.cassette3Load * 20) + (atm.cassette4Load * 20);
          return (
            <Grid container spacing={1} sx={{ padding: 1, borderBottom: "1px solid #e0e0e0" }} key={atm.assetId}>
            <Grid size={1} sx={{ flexGrow: 1 }}><Typography variant="h6">{atm.assetId}</Typography></Grid>
            <Grid size={1} sx={{ flexGrow: 1 }}>
              <TextField
                type="number"
                variant="outlined"
                size="small"
                value={atm.startAmount || ''}
                onChange={(e) => handleBlur(index, 'startAmount', e.target.value)}
              />
            </Grid>
              <Grid size={1} sx={{ flexGrow: 1 }}>
              <TextField
                type="number"
                variant="outlined"
                size="small"
                value={atm.cassette1Load || ''}
                onChange={(e) => handleBlur(index, 'cassette1Load', e.target.value)}
              />
            </Grid>
            <Grid size={1} sx={{ flexGrow: 1 }}>
              <TextField
                type="number"
                variant="outlined"
                size="small"
                value={atm.cassette2Load || ''}
                onChange={(e) => handleBlur(index, 'cassette2Load', e.target.value)}
              />
            </Grid>
            <Grid size={1} sx={{ flexGrow: 1 }}>
              <TextField
                type="number"
                variant="outlined"
                size="small"
                value={atm.cassette3Load || ''}
                onChange={(e) => handleBlur(index, 'cassette3Load', e.target.value)}
              />
            </Grid>
            <Grid size={1} sx={{ flexGrow: 1 }}>
              <TextField
                type="number"
                variant="outlined"
                size="small"
                value={atm.cassette4Load || ''}
                onChange={(e) => handleBlur(index, 'cassette4Load', e.target.value)}
              />
            </Grid>
            <Grid size={1} sx={{ flexGrow: 1 }}>
              <Typography variant="h6">{atm.balanceAtDeparture || 0}</Typography>
            </Grid>
          </Grid>
          )})}
      </Box>
    </StandardModal>
  );
};

export default LocationVisitAtmForm;
